import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from '../context/TranslationContext';
import './Header.css';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();
  const { t, switchLanguage, language } = useTranslation();

  const isActive = (path) => {
    return location.pathname === path ? 'active' : '';
  };

  return (
    <header className="header">
      <div className="container">
        <div className="top-header">
          <div className="logo">
            <div className="logo-placeholder">
              <img src="/images/englogo.png" loading='lazy' alt="Ramson Feeds Logo" />
            </div>
            <div className="logo-text">
              <h1>{t('companyName')}</h1>
              <p>{t('tagline')}</p>
            </div>
          </div>
          <div className="address">
            <p>37/2, Elumalai Gounder Vattam<br />Kandampatty, Salem-636005</p>
          </div>
            <div className="language-switcher">
              <button 
                className={`lang-btn ${language === 'en' ? 'active' : ''}`}
                onClick={() => switchLanguage('en')}
              >
                ENG
              </button>
              <button 
                className={`lang-btn ${language === 'ta' ? 'active' : ''}`}
                onClick={() => switchLanguage('ta')}
              >
                தமிழ்
              </button>
            </div>
            <a href="tel:+919443245877" className="call-button">
              <i className="fas fa-phone"></i> {t('callUs')}: +91 9443245877
            </a>
          
          <button 
            className="mobile-menu-btn"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            <i className="fas fa-bars"></i>
          </button>
        </div>
      </div>
      
      <nav className="navigation">
        <div className="container">
          <ul className={`nav-links ${isMenuOpen ? 'active' : ''}`}>
            <li><Link to="/" className={isActive('/')} onClick={() => setIsMenuOpen(false)}>{t('home')}</Link></li>
            <li><Link to="/about" className={isActive('/about')} onClick={() => setIsMenuOpen(false)}>{t('about')}</Link></li>
            {/* <li><Link to="/gallery" className={isActive('/gallery')} onClick={() => setIsMenuOpen(false)}>{t('gallery')}</Link></li> */}
            <li><Link to="/products" className={isActive('/products')} onClick={() => setIsMenuOpen(false)}>{t('products')}</Link></li>
            <li><Link to="/contact" className={isActive('/contact')} onClick={() => setIsMenuOpen(false)}>{t('contact')}</Link></li>
          </ul>
        </div>
      </nav>
    </header>
  );
};

export default Header;